import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormConstants } from '../../../../constants/form.constants';
import { NavigationService } from '../../../../services/navigation.service';
import { Subscription } from 'rxjs';
import { UsanFormSectionStates } from '../../../../models/usan-form-section-states.model';
import { ViewportScroller } from '@angular/common';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { FormService } from 'app/services/form.service';
import { FormGroup } from '@angular/forms';
import { FormValidationService } from 'app/services/form-validation.service';

@Component({
  selector: 'app-form-left-nav',
  templateUrl: './form-left-nav.component.html',
  styleUrls: ['./form-left-nav.component.scss']
})
export class FormLeftNavComponent implements OnInit, OnDestroy {

  formSectionStates!: UsanFormSectionStates;

  private usanFormSectionSubscription: Subscription;
  private sizeChangeSubscription!: Subscription;
  private mobileDeviceSize: boolean = false;


  constructor(
    protected navigationService: NavigationService, 
    private formService: FormService, 
    private responsive: BreakpointObserver, 
    protected scroller: ViewportScroller,
    protected formValidationService: FormValidationService
  ) {
    this.usanFormSectionSubscription = this.navigationService.getUsanFormSectionStatesUpdate().subscribe(
      usanFormSection => {
        this.formSectionStates = usanFormSection.value;
      });

    this.formSectionStates = this.navigationService.getUsanFormSectionValue();

    this.formValidationService.resetSectionValidityMap();
    
    this.sizeChangeSubscription = this.responsive.observe([Breakpoints.Handset]).subscribe(result => {
      if(result.matches) {
        this.mobileDeviceSize = true;
      } else {
        this.mobileDeviceSize = false;
      }
    });
  }
  
  ngOnInit(): void {
    this.formService.invalidFormFields();
  }

  ngOnDestroy(): void {
    this.usanFormSectionSubscription.unsubscribe();
    this.sizeChangeSubscription.unsubscribe();
  }

  get formSectionsInfo() {
    return FormConstants.FORM_SECTION_NAME_MAP;
  }

  public isSelectedSection(sectionKey: string): boolean {
    return this.formSectionStates[sectionKey];
  }

  public sectionHasError(sectionName: string): boolean {
    return this.formValidationService.sectionHasError(sectionName);
  }

  get currentForm(): FormGroup {
    return this.formService.getCurrentUsanFormValue();
  }

  public changeSection(sectionKey: string) {
    
    if(this.currentForm.touched && this.currentForm.dirty) {
      this.navigationService.saveFormandSendUsanFormSectionStatesUpdate(sectionKey);
      if(this.formService.isShowingErrorSections) {
        this.formService.invalidFormFields();
      }
    } else {
      this.navigationService.sendUsanFormSectionStatesUpdate(sectionKey);
    }
    
    if (!this.mobileDeviceSize)
      this.scroller.scrollToAnchor('tabs-bar');
  }

}
